<template>
	<div class="iamge_content">
		<img :src="companyImg" alt="">
		<CopyrightBottom></CopyrightBottom>
	</div>
</template>

<script type="text/javascript">
	import Vue from "vue";
	import store from '@/store/index.js';

	export default{
		name:"companyProfile",
		data(){
			return{
				companyImg:''
			}
		},

		computed:{
			allProductDate(){
				return store.state.product_data;
			}
		},
		watch: {
			allProductDate:{
				immediate:true,
				deep:true,
				handler:function(newValue,oldValue){
					var self = this;
					if (newValue == null || newValue.config == null) {
						 return
					 }
					 console.log(newValue)
					self.companyImg = newValue.config.company_introduce_url
				}
			}
		},
		methods:{
		}
	}

</script>

<style type="text/css" scoped>
	.iamge_content{
		/* position: fixed; */
		/* height: 100%; */
		width: 100%;
		margin: 0;
		padding: 0;
	}
	img{
		/* height: 100%; */
		margin-top: 50px;
		width: 100%;
		/* position: absolute; */
		/* background: green; */
		display: block;
	}
</style>


// WEBPACK FOOTER //
// src/pages/companyProfile.vue